import { render, staticRenderFns } from "./settingEmployeeRoles.vue?vue&type=template&id=b133db2c&"
import script from "./settingEmployeeRoles.vue?vue&type=script&lang=js&"
export * from "./settingEmployeeRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports